import { render, staticRenderFns } from "./EditInside.vue?vue&type=template&id=68b31398&scoped=true&"
import script from "./EditInside.vue?vue&type=script&lang=js&"
export * from "./EditInside.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b31398",
  null
  
)

export default component.exports